import FileManagerDialog from './FileManagerDialog';

export default FileManagerDialog;
